import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { PreAuthenticationResponse, RegisterRequestModel, LogonTypeEnum, PrivateDataModel, LogonRequest, LogonResponse, PermissionType } from '@picard/models-lib';
import { StorageConstants } from '@picard/shared-lib';
import { AuthenticationService, PreAuthenticationService, ApplicationService } from '@picard/services-lib';
import Swal from 'sweetalert2';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Message } from 'primeng/primeng';

@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.css']
})
export class OtpComponent implements OnInit {
  //#region Properties
  preAuthenticationResponse: PreAuthenticationResponse;
  mobileNumber: string;
  membershipNumber: string;
  showRetry: boolean;
  inRegistration: boolean;
  otp: any;
  partnerCode: string;
  msgs: Message[] = [];
  @BlockUI() blockUI: NgBlockUI;
  docTheme = document.getElementById('theme-css');
  docLayout = document.getElementById('layout-css');
  //#endregion Properties

  //#region Constructor
  constructor(private _authenticationService: AuthenticationService, private _router: Router, private _activatedRoute: ActivatedRoute, private _preAuthenticationService: PreAuthenticationService, private _applicationService: ApplicationService) {
    this.inRegistration = false;

    if (this.docTheme) {
      this.docTheme.setAttribute('href', this._applicationService.preAuthenticationResponse.programmeAssetsModel.theme);
    }
    if (this.docLayout) {
      this.docLayout.setAttribute('href', this._applicationService.preAuthenticationResponse.programmeAssetsModel.layout);
    }
  }
  //#endregion Constructor

  //#region Functions
  async ngOnInit() {
    this._activatedRoute.queryParams.subscribe((params: Params) => (this.partnerCode = params['partner']));
    this.msgs = [];
    this.msgs.push({ severity: 'info', detail: `Please enter the number you use on the keypad at Seattle Coffee Company, this is your Loyalty Number` });
    const hostInformation = location.hostname.split('.', 3);
    if (hostInformation[0].toLowerCase() !== 'localhost') {
      this.partnerCode = hostInformation[0];
    }
    let preAuthJson = sessionStorage.getItem(StorageConstants.preAuth);
    if (preAuthJson) {
      this.preAuthenticationResponse = JSON.parse(preAuthJson);
      this.setBody();
    } else {
      const preAuthResponse = await this._preAuthenticationService.PreAuthenticationAsync(this.partnerCode);
      sessionStorage.setItem(StorageConstants.preAuth, JSON.stringify(preAuthResponse));
      preAuthJson = sessionStorage.getItem(StorageConstants.preAuth);
      this.preAuthenticationResponse = JSON.parse(preAuthJson);
      this.setBody();
    }
  }
  setBody() {
    const htmlBody: HTMLLinkElement = <HTMLLinkElement>document.getElementById('picard-body');
    if (htmlBody !== null) {
      htmlBody.className = 'login-body';
      htmlBody.style.backgroundImage = `url("${this.preAuthenticationResponse.programmeAssetsModel.imageAssetsModel.bodyUrl}")`;
    }
  }
  async startRegistration() {
    const registerRequestModel = new RegisterRequestModel();
    registerRequestModel.programmeId = this.preAuthenticationResponse.programId;
    registerRequestModel.logonType = LogonTypeEnum.Mobile_Number;
    registerRequestModel.logonTypeValue = this.mobileNumber;
    registerRequestModel.membershipNumber = this.membershipNumber;
    registerRequestModel.permissionType = PermissionType.user;
    this.blockUI.start('Trying to register.');
    const response = await this._authenticationService.registerAsync(registerRequestModel);
    this.blockUI.stop();
    if (!response.isSuccessful) {
      Swal('Number entered: ' + this.mobileNumber, response.customMessage, 'error');
      this.inRegistration = false;
    } else {
      this.inRegistration = true;
    }
  }
  async addValue(num) {
    if (!this.otp) {
      this.otp = '';
    }
    if (this.otp.length < 5) {
      this.otp += num;
    }
    if (this.otp.length === 5) {
      const privateDataModel = new PrivateDataModel();
      privateDataModel.logonType = this.preAuthenticationResponse.loginType;
      privateDataModel.password = this.otp;
      privateDataModel.typeValue = this.mobileNumber;

      const logonRequest = new LogonRequest();
      logonRequest.programmeShortCode = this.preAuthenticationResponse.code;
      logonRequest.privateData = btoa(JSON.stringify(privateDataModel));
      this.blockUI.start('Logging you in.');
      const authenticationAsyncResponse = await this._authenticationService.AuthenticationAsync(logonRequest);
      this.blockUI.stop();
      this.logonSuccessMessage(authenticationAsyncResponse);
    }
  }
  logonSuccessMessage(response: LogonResponse) {
    if (response.isLoggedOn) {
      sessionStorage.setItem(StorageConstants.loginDetails, JSON.stringify(response));
      Swal({ type: 'success', title: 'Logon successful', showConfirmButton: false, timer: 1500 });
      this._router.navigateByUrl('/dashboard');
    } else {
      Swal({ type: 'error', title: 'Logon failed:' + response.customLogonMessage, showConfirmButton: false, timer: 2000 });
    }
  }
  //#endregion Functions
}
